"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.9974 1a11 11 0 1 0 .0052 22 11 11 0 0 0-.0052-22zm5.0436 15.865a.6852.6852 0 0 1-.6917.3208.6861.6861 0 0 1-.2514-.0923c-2.5822-1.5761-5.8329-1.936-9.6616-1.0613a.6848.6848 0 0 1-.732-.2603.6861.6861 0 0 1-.0189-.7766.6843.6843 0 0 1 .4449-.2988c4.1898-.9588 7.7847-.5464 10.6834 1.2254a.6861.6861 0 0 1 .323.6913.6849.6849 0 0 1-.0918.2518h-.0039zm1.3462-2.9947a.8585.8585 0 0 1-.8676.3989.8596.8596 0 0 1-.3145-.1165c-2.9565-1.8178-7.4629-2.3431-10.9606-1.2819a.8586.8586 0 0 1-.6533-.0644.858.858 0 0 1 .1555-1.5774c3.9942-1.211 8.9603-.6239 12.3555 1.4619a.8588.8588 0 0 1 .289 1.1794h-.004zm.1156-3.1194C14.9565 8.6494 9.1091 8.4524 5.7244 9.4795a1.0292 1.0292 0 1 1-.5963-1.9701c3.8852-1.1821 10.3433-.9523 14.4255 1.471a1.0293 1.0293 0 0 1 .4929 1.0315 1.0293 1.0293 0 0 1-.7643.8501 1.028 1.028 0 0 1-.7794-.1124v.0013z"
  })];
};

exports.default = _default;